import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { selectors as ChannelsSelectors } from 'data/channels'
import { getChannelLabel } from 'data/channels/helpers'
import { getRawViewState } from 'data'
import { MainPanel, MainBodyContainer } from 'components/Layout/AppLayout'
import { getChannelViewName } from 'components/viewNames'
import Unknown from 'components/Errors/Unknown'
import { NotFound, Forbidden } from 'components/Errors/Channel'
import NoConnection from 'components/Errors/InAppNoConnection'

import syncsChannel from './dataSync'

const errorTypes = {
  NOT_FOUND: NotFound,
  UNAUTHORIZED: Forbidden,
  UNKNOWN: Unknown,
  NO_CONNECTION: NoConnection,
}

class ChannelsIndex extends Component {
  renderErrors() {
    const { errors, channelId, canAccess } = this.props
    let mapError = null

    try {
      mapError = errors.values().next().value
    } catch (error) {}

    if (mapError && mapError.toString().includes('Failed to fetch')) {
      return <errorTypes.NO_CONNECTION />
    }

    if (!errors.size && !canAccess) {
      return React.createElement(errorTypes.NOT_FOUND, { channelId })
    }

    return errors.reduce((ErrorComponent, { errors }) => {
      if (errors && errors[0]) {
        if (errors[0].status === 404) {
          return React.createElement(errorTypes.NOT_FOUND, { channelId })
        }
        if (errors[0].status === 403) {
          return React.createElement(errorTypes.UNAUTHORIZED, {
            channelId,
            isPersonal:
              errors[0].id ===
              'channel/access-forbidden/personal-without-ownership',
          })
        }
      }
      return ErrorComponent
    }, React.createElement(errorTypes.UNKNOWN, { channelId }))
  }

  render() {
    const { errors, canAccess, children, isLoaded } = this.props
    if (errors.size || (isLoaded && !canAccess)) {
      // render an error but give opportunity to children to fix the situation
      return (
        <>
          {this.renderErrors()}
          <div style={{ display: 'none' }}>{children}</div>
        </>
      )
    }

    return (
      <MainBodyContainer>
        <MainPanel>{children}</MainPanel>
      </MainBodyContainer>
    )
  }
}

export default compose(
  syncsChannel(),
  connect((state, { channelId }) => {
    const { errors } = getRawViewState(state, getChannelViewName(channelId))
    const channel = ChannelsSelectors.getChannel(state, channelId)

    const isLoaded = Boolean(channel)
    const canAccess =
      channel && channel.permissions && channel.permissions.get('read')
    const channelLabel = getChannelLabel(channel)
    const channelType = channel && channel.type

    return {
      isLoaded,
      channelId,
      channelLabel,
      channelType,
      errors,
      canAccess,
    }
  })
)(ChannelsIndex)
